import React from 'react';
import {useUserInteraction} from '@rocket-ui/user-interaction';
import {useDeclineTask} from '@rocket-ui/lk-api';
import {isAxiosError} from 'axios';

export type DeclineDrawerStep = 'confirm' | 'success';

function getDeclineErrorMessage(error: unknown): string {
	if (isAxiosError<{errors?: string[]; message?: string; detail?: string}>(error)) {
		return error.response?.data?.errors?.[0] || error.response?.data?.message || error.response?.data?.detail || error.message;
	}

	return error instanceof Error ? error.message : 'Не удалось отклонить заказ';
}

export function useDeclineTaskDrawer(taskId: number | string) {
	const {mutate: decline, isLoading: isDeclining} = useDeclineTask();
	const {notifyUser} = useUserInteraction();
	const [isOpen, setIsOpen] = React.useState(false);
	const [step, setStep] = React.useState<DeclineDrawerStep>('confirm');

	const open = React.useCallback(() => {
		setStep('confirm');
		setIsOpen(true);
	}, []);

	const close = React.useCallback(() => {
		if (isDeclining) return;
		setIsOpen(false);
		setStep('confirm');
	}, [isDeclining]);

	const confirm = React.useCallback(() => {
		decline(
			{id: String(taskId)},
			{
				onSuccess: () => setStep('success'),
				onError: (error) => {
					setIsOpen(false);
					setStep('confirm');
					notifyUser(getDeclineErrorMessage(error));
				},
			},
		);
	}, [decline, notifyUser, taskId]);

	const continueAfterSuccess = React.useCallback(() => {
		setIsOpen(false);
		setStep('confirm');
	}, []);

	return {
		isOpen,
		step,
		isDeclining,
		open,
		close,
		confirm,
		continueAfterSuccess,
	};
}

